import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FirRemoto, OperazioniDisponibili, OutputEventCampi, OutputEventCampiErrors, OutputEventCampiInit, OutputEventCampiStatus, OutputEventCampiValue, Soggetto } from '../../interfaces';
import { AbstractControl, AsyncValidatorFn, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { alert } from 'devextreme/ui/dialog';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { Apiservice } from '../../../../services/api.service';
import { DocumentTask, FirDigitaliTransactionService, TransactionStateMap } from '../../../../services/fir-digitali-transaction.service';

@Component({
  selector: 'app-dati-trasporto',
  templateUrl: './dati-trasporto.component.html',
  styleUrls: ['./dati-trasporto.component.css']
})
export class DatiTrasportoComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() operazioniDisponibili: OperazioniDisponibili
  @Input() soggetto: Soggetto
  @Input() group: Array<"TrasportoUpdate" | "Trasporto">;
  @Input() firRemoto: FirRemoto
  @Input() sezioneGroup: string
  @Input() meta: { [key: string]: boolean } = {}
  @Output() initGroup = new EventEmitter<OutputEventCampiInit>();
  @Output() statusChange = new EventEmitter<OutputEventCampiStatus>();
  @Output() errorsChange = new EventEmitter<OutputEventCampiErrors>();
  @Output() valueChange = new EventEmitter<OutputEventCampiValue>();
  protected formGroups: FormGroup = this.fb.group({})
  protected currentGroup: string = ''
  // protected isDisabled: boolean = false
  protected selectedTipoTrasp: 'Terrestre' | 'Marittimo' | 'Ferroviario' = 'Terrestre'
  protected fields: Record<string, {
    label: string;
    validators?: ValidatorFn[];
    asyncValidators?: AsyncValidatorFn[];
    items?: {
      dataSource?: DataSource | any[];
      displayExpr?: string | ((item: any) => string);
      valueExpr?: string | ((item: any) => string);
    }
  }>
  private destroy$ = new Subject<void>();

  constructor(private readonly fb: FormBuilder, private readonly Apiservice: Apiservice, private readonly FirTransaction: FirDigitaliTransactionService) { }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  ngAfterViewInit(): void {
    console.log(this)
    this.initGroup.emit({
      name: 'onInit',
      value: this.formGroups.value,
      formGroups: this.formGroups,
      sezione: this.sezioneGroup,
      component: this,
      touched: false,
    })
  }

  ngOnInit() {
    if (!this.group || !this.soggetto || !this.operazioniDisponibili || !this.firRemoto) alert('Errore', 'Attenzione');
    else {
      this.currentGroup = this.meta['Trasporto'] === true ? 'Trasporto' : 'TrasportoUpdate';
      this.processFieldsMetadata();
      this.processFormGroup()
      // this.datiTipoTrasporto = this.getTipoTrasporto()

      this.formGroups.statusChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => this.emitEvents());

      this.formGroups.valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(value => {
          const touched = this.isFormTouched()
          this.valueChange.emit({ name: 'valueChange', formGroups: this.formGroups, value: value, sezione: this.sezioneGroup, component: this, touched });
          this.emitEvents();
        });
      // this.FirTransaction.globalQueue$.pipe(takeUntil(this.destroy$)).subscribe({
      //   next: (next: DocumentTask[]) => {
      //     this.isDisabled = next.length > 0 ? next.some((task) => (task.status !== 'error' && task.status !== 'completed') ?
      //       this.group.includes(task.processId as any) : false) : false
      //   },
      // })
      // this.FirTransaction.state$.pipe(takeUntil(this.destroy$)).subscribe({
      //   next: (next: TransactionStateMap) => {
      //     this.isDisabled = next[this.firRemoto.dati_partenza.numero_fir] ?
      //       (next[this.firRemoto.dati_partenza.numero_fir].status !== 'error' && next[this.firRemoto.dati_partenza.numero_fir].status !== 'completed') ?
      //         next[this.firRemoto.dati_partenza.numero_fir].listTask.some((val) => (val.status !== 'completed' && val.status !== 'error') ? this.group.includes(val.processId as any) : false)
      //         : false : false
      //   },
      // })
    }
  }

  hasError(actionKey: string, fieldKey: string): boolean {
    const group = this.getForm(actionKey);
    if (!group) return false;
    const control = group.get(fieldKey);
    if (!control) return false;
    if (!control.touched) return false;
    if (!this.isFormTouched()) return false;
    return control.invalid;
  }
  getForm(key: string): FormGroup | null {
    if (!this.formGroups.get(key)) return null
    return this.formGroups.get(key) as FormGroup;
  }
  getValue(key: string, field: string): FormGroup | null {
    if (!this.formGroups.get(key)) return null
    const group = this.formGroups.get(key) as FormGroup;
    const campo = group.get(field)
    if (!campo) return null
    return campo.value;
  }

  onDxChange(group, field, event) {
    const gruppo = this.formGroups.get(group)
    if (!gruppo) return
    const control = gruppo.get(field)
    if (!control) return
    control.setValue(event.value)
    gruppo.updateValueAndValidity()
  }
  //! -------------------------------------------------------------------------
  private isFormTouched(): boolean {
    const traspIniz = this.firRemoto.dati_trasporto ? this.firRemoto.dati_trasporto[0] : {};
    const obj = {}
    Object.assign(obj, traspIniz)
    const normalize = (val: any): any => {
      if (val === null || val === undefined || val === '') return null;
      if (typeof val === 'object' && 'nome' in val && 'cognome' in val) {
        return `${val.cognome} ${val.nome}`.trim();
      }
      if (val instanceof Date) return val.toISOString();
      if (typeof val === 'number') return val.toString();
      return val;
    }
    const isEqual = (a: any, b: any): boolean => {
      const na = normalize(a);
      const nb = normalize(b);
      return JSON.stringify(na) === JSON.stringify(nb);
    }
    for (const actionKey of this.group) {
      if (this.meta[actionKey] === false) continue;
      const group = this.getForm(actionKey);
      if (!group) continue;

      const current = group.getRawValue();

      for (const key of Object.keys(current)) {
        if (!(key in obj)) obj[key] = null

        const original = obj[key];
        const now = current[key];
        if (!isEqual(now, original)) {
          return true;
        }

      }
    }

    return false;
  }

  private emitEvents(): void {
    const messages = []
    for (const actionKey of this.group) {
      if (this.meta[actionKey] === false) continue;
      const group = this.getForm(actionKey);
      if (!group) continue;

      const value = group.getRawValue();
      for (const field of Object.keys(value)) {
        const msg = this.getErrorMessage(actionKey, field);
        if (msg) messages.push(msg);
      }
    }
    const status = this.formGroups.status === 'VALID' ? 'VALID' : 'INVALID';
    const touched = this.isFormTouched()
    this.statusChange.emit({ name: 'statusChange', status, formGroups: this.formGroups, sezione: this.sezioneGroup, component: this, touched });
    this.errorsChange.emit({ name: 'errorsChange', errors: messages, formGroups: this.formGroups, sezione: this.sezioneGroup, component: this, touched });
  }

  private getErrorMessage(actionKey: string, field: string): string | null {
    const group = this.getForm(actionKey);
    const control = group.get(field);
    if (!control || !control.errors) return null;
    const errors = control.errors;
    const fallbackMessages: Record<string, (err: any) => string> = {
      required: () => `Campo ${this.fields[field].label} obbligatorio`,
      minlength: err => `Campo ${this.fields[field].label} minimo ${err.requiredLength} caratteri`,
      maxlength: err => `Campo ${this.fields[field].label} massimo ${err.requiredLength} caratteri`,
      min: err => `Campo ${this.fields[field].label} valore minimo ${err.min}`,
      max: err => `Campo ${this.fields[field].label} valore massimo ${err.max}`,
      pattern: () => `Campo ${this.fields[field].label} non valido`,
      custom: err => typeof err === 'string' ? err : `${this.fields[field].label} non valido`,
      async: err => typeof err === 'string' ? err : `${this.fields[field].label} non valido`,
    };
    for (const key of Object.keys(errors)) {
      const err = errors[key];
      if (fallbackMessages[key]) return fallbackMessages[key](err);
    }
    return `Campo non valido`;
  }

  private dynamicGroupActivation(
    validatorsMap: Record<string, ValidatorFn[]>
  ): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      if (!(group instanceof FormGroup)) return null;
      const controls = Object.entries(group.controls);
      const values = controls.map(([_, ctrl]) => (ctrl.value || '').toString().trim());
      const hasValue = values.some(v => v !== '');
      for (const [field, ctrl] of controls) {
        const originalValidators = validatorsMap[field] || [];
        if (hasValue) {
          ctrl.setValidators(originalValidators);
        } else {
          ctrl.clearValidators();
        }
        ctrl.updateValueAndValidity({ emitEvent: false, onlySelf: true });
      }
      return null;
    };
  }

  private processFormGroup() {
    const tipoTrasporto = this.getTipoTrasporto()
    if (!tipoTrasporto) return;
    this.selectedTipoTrasp = tipoTrasporto
    for (const key of this.group) {
      const subGroup = this.fb.group({});
      this.formGroups.addControl(key, subGroup);
      this.buildTrasportoForm(subGroup, this.selectedTipoTrasp, key);
    }
  }

  //TODO da testare
  private getTipoTrasporto(): ('Terrestre' | 'Marittimo' | 'Ferroviario') | null {
    const trasportatori = this.firRemoto.dati_partenza.trasportatori;
    if (!trasportatori || trasportatori.length === 0) return null
    const datiTrasporto = this.firRemoto.dati_trasporto || [];

    // Nessun trasporto iniziato → usa il primo trasportatore
    if (datiTrasporto.length === 0) {
      return trasportatori[0].tipo_trasporto || null;
    }

    for (const trasp of trasportatori) {
      const record = datiTrasporto.find(
        d => d.trasportatore_id === trasp.trasportatore_id
      );

      // Caso 1: esiste record ma non ha ancora firmato → trasportatore attuale
      if (record && record.dati_firma_trasportatore === null) {
        return trasp.tipo_trasporto;
      }

      // Caso 2: non esiste record → trasportatore successivo
      if (!record) {
        return trasp.tipo_trasporto;
      }
    }

    // Tutti i trasportatori hanno record e hanno già firmato
    return null;
  }


  private buildTrasportoForm(subGroup: FormGroup, tipo_trasporto: 'Terrestre' | 'Marittimo' | 'Ferroviario', operazione: 'Trasporto' | 'TrasportoUpdate') {
    const data = {
      data_ora_inizio_trasporto: null,
      annotazioni: '',
      conducente: null,
      targa_automezzo: null,
      targa_rimorchio: null,
      percorso: '',
      presa_in_carico_rimorchio_precedente: false,
      nave: '',
      imdg: false,
      treno: '',
      rid: false,
      tratta: '',
    }
    if (operazione === 'TrasportoUpdate' && this.firRemoto.dati_trasporto && this.firRemoto.dati_trasporto.length > 0) {
      const traspIniz = this.firRemoto.dati_trasporto[0]
      data.data_ora_inizio_trasporto = traspIniz.data_ora_inizio_trasporto
      data.annotazioni = traspIniz.annotazioni
      switch (traspIniz.tipo_trasporto) {
        case 'Ferroviario':
          data.treno = traspIniz.treno
          data.tratta = traspIniz.tratta
          data.rid = traspIniz.rid
          break;
        case 'Marittimo':
          data.imdg = traspIniz.imdg
          data.nave = traspIniz.nave
          break;
        case 'Terrestre':
          data.conducente = traspIniz.conducente.cognome + ' ' + traspIniz.conducente.nome
          data.targa_automezzo = traspIniz.targa_automezzo
          data.targa_rimorchio = traspIniz.targa_rimorchio
          data.percorso = traspIniz.percorso
          data.presa_in_carico_rimorchio_precedente = traspIniz.presa_in_carico_rimorchio_precedente
          break;
        default:
          break;
      }
    }
    subGroup.addControl('tipo_trasporto', this.fb.control(tipo_trasporto));
    switch (tipo_trasporto) {
      case 'Terrestre':
        subGroup.addControl('data_ora_inizio_trasporto', this.fb.control(data.data_ora_inizio_trasporto));
        subGroup.addControl('annotazioni', this.fb.control(data.annotazioni));
        subGroup.addControl('conducente', this.fb.control(data.conducente));
        subGroup.addControl('targa_automezzo', this.fb.control(data.targa_automezzo));
        subGroup.addControl('targa_rimorchio', this.fb.control(data.targa_rimorchio));
        subGroup.addControl('percorso', this.fb.control(data.percorso));
        subGroup.addControl('presa_in_carico_rimorchio_precedente', this.fb.control(data.presa_in_carico_rimorchio_precedente));
        break;
      case 'Marittimo':
        subGroup.addControl('data_ora_inizio_trasporto', this.fb.control(data.data_ora_inizio_trasporto));
        subGroup.addControl('annotazioni', this.fb.control(data.annotazioni));
        subGroup.addControl('nave', this.fb.control(data.nave));
        subGroup.addControl('imdg', this.fb.control(data.imdg));
        break;
      case 'Ferroviario':
        subGroup.addControl('data_ora_inizio_trasporto', this.fb.control(data.data_ora_inizio_trasporto));
        subGroup.addControl('annotazioni', this.fb.control(data.annotazioni));
        subGroup.addControl('treno', this.fb.control(data.treno));
        subGroup.addControl('rid', this.fb.control(data.rid));
        subGroup.addControl('tratta', this.fb.control(data.tratta));
        break;
      default:
        break;
    }
    const validatorsMap: Record<string, ValidatorFn[]> = {};
    for (const fieldName of Object.keys(subGroup.controls)) {
      if (!this.fields[fieldName]) continue;
      validatorsMap[fieldName] = this.fields[fieldName].validators || [];
    }
    if (this.meta[operazione] === false) return;
    else return subGroup.setValidators(this.dynamicGroupActivation(validatorsMap));
  }

  private processFieldsMetadata() {
    this.fields = {
      data_ora_inizio_trasporto: {
        label: 'Data e Ora',
        validators: [Validators.required]
      },
      annotazioni: {
        label: 'Annotazioni',
        validators: []
      },
      conducente: {
        label: 'Conducente',
        validators: [Validators.required],
        items: {
          dataSource: this.createDataSource(`Autista/GetAllByIdSoggetto`, ['cognome', 'nome'], ['cognome', 'nome'], `idSoggetto=${this.soggetto.id}&$filter=(isAutista eq true)`, 10, true, this.soggetto),
          displayExpr: item => item && item.nome && item.cognome ? `${item.cognome} ${item.nome}` : '',
          valueExpr: item => item && item.nome && item.cognome ? `${item.cognome} ${item.nome}` : ''
        }
      },
      targa_automezzo: {
        label: 'Automezzo',
        validators: [Validators.required],
        items: {
          dataSource: this.createDataSource(`Automezzo/GetAllByIdSoggetto`, 'targa', 'targa', `idSoggetto=${this.soggetto.id}&$filter=(tipoautomezzo ne 'D')`, 10, true, this.soggetto),
          displayExpr: 'targa',
          valueExpr: 'targa'
        }
      },
      targa_rimorchio: {
        label: 'Rimorchio',
        validators: [],
        items: {
          dataSource: this.createDataSource(`Automezzo/GetAllByIdSoggetto`, 'targa', 'targa', `idSoggetto=${this.soggetto.id}&$filter=(tipoautomezzo in ('D','E','F'))`, 10, true, this.soggetto),
          displayExpr: 'targa',
          valueExpr: 'targa'
        }
      },
      percorso: {
        label: 'Percorso',
        validators: []
      },
      presa_in_carico_rimorchio_precedente: {
        label: 'Presa in carico rimorchio',
        validators: []
      },
      nave: {
        label: 'Nave',
        validators: []
      },
      imdg: {
        label: '',
        validators: []
      },
      treno: {
        label: 'Treno',
        validators: []
      },
      rid: {
        label: '',
        validators: []
      },
      tratta: {
        label: 'Tratta',
        validators: []
      },
    }
  }

  private createDataSource(
    endpoint: string,
    keyField: string | string[] = 'id',
    displayField: string | string[] = 'id',
    filterPart: string = '',
    pageSize: number = 10,
    isPreCheck: boolean = false,
    chechkValue?: any,
    transformFn?: (items: any[]) => any[],
  ) {
    return new DataSource({
      store: new CustomStore({
        key: keyField,
        load: async (loadOptions: any) => {
          if (isPreCheck && !chechkValue) return { data: [], totalCount: 0 };
          try {
            const skip = loadOptions.skip || 0;
            const take = loadOptions.take || pageSize;
            let currentFilterPart = '&' + filterPart.replace('?', '');
            if (loadOptions.searchValue && loadOptions.searchValue.trim() !== '') {
              const s = loadOptions.searchValue.trim().toLowerCase();

              if (!Array.isArray(displayField)) {
                if (currentFilterPart.includes('$filter=')) {
                  currentFilterPart = currentFilterPart.replace(
                    '$filter=',
                    `$filter=contains(tolower(${displayField}), '${s}') and `
                  );
                } else {
                  currentFilterPart += `&$filter=contains(tolower(${displayField}), '${s}')`;
                }
              } else {
                displayField.forEach((val) => {
                  if (currentFilterPart.includes('$filter=')) {
                    currentFilterPart = currentFilterPart.replace(
                      '$filter=',
                      `$filter=contains(tolower(${val}), '${s}') and `
                    );
                  } else {
                    currentFilterPart += `&$filter=contains(tolower(${val}), '${s}')`;
                  }
                })
              }
            }
            const url =
              `${endpoint}?$skip=${skip}&$top=${take}&$count=true` +
              currentFilterPart;
            const res: any = await this.Apiservice.GetApi(url);
            let items = res.items || [];
            if (transformFn) items = transformFn(items);
            return {
              data: items,
              totalCount: res.totalCount || 0,
            };
          } catch (e) {
            console.error("Errore load generic", e);
            throw e;
          }
        },

        byKey: async (key: string) => {
          if (isPreCheck && !chechkValue) return null;
          if (!key) return null;

          try {
            const displayExpr = displayField; // FIX !!!

            const raw = filterPart || "";

            const baseQuery = raw
              .replace(/\$filter=[^&]*/, "")
              .replace(/&&+/g, "&")
              .replace(/^&/, "")
              .replace(/&$/, "");

            const match = raw.match(/\$filter=([^&]*)/);
            const originalFilter = match ? match[1] : null;

            const keyConditions: string[] = [];

            if (!Array.isArray(keyField)) {
              keyConditions.push(`${keyField} eq '${key}'`);
            } else {
              const parts = key.split(" ");
              keyField.forEach((field, i) => {
                if (parts[i]) keyConditions.push(`${field} eq '${parts[i]}'`);
              });
            }

            const allFilters = [];
            if (originalFilter) allFilters.push(`(${originalFilter})`);
            if (keyConditions.length > 0) allFilters.push(...keyConditions);

            const finalFilter = `$filter=${allFilters.join(" and ")}`;

            let url = `${endpoint}?`;
            if (baseQuery) url += baseQuery + "&";
            url += finalFilter;

            const res: any = await this.Apiservice.GetApi(url);
            let items = res.items || [];
            if (transformFn) items = transformFn(items);

            // FALLBACK CORRETTO
            if (items.length === 0) {
              const fallback: any = {};

              // key
              if (!Array.isArray(keyField)) {
                fallback[keyField] = key;
              } else {
                const parts = key.split(" ");
                keyField.forEach((field, i) => fallback[field] = parts[i] || null);
              }

              // display
              if (!Array.isArray(displayExpr)) {
                fallback[displayExpr] = key;
              } else {
                const parts = key.split(" ");
                displayExpr.forEach((field, i) => {
                  fallback[field] = parts[i] || null;
                });
              }

              return fallback;
            }

            return items[0];

          } catch (e) {
            console.error("Errore byKey generic", e);
            throw e;
          }
        }

      }),
      paginate: true,
      pageSize,
      searchExpr: displayField,
    });
  }
}
